import qs from 'qs';

/**
 * Builds the register-page href, carrying the entered identifier as `email` (so the register form
 * can prefill it) and any `next` redirect so both survive the login → register hop. Shared by the
 * "Sign up" link and the auto-redirect when an identifier resolves to no orgs, so the two can't
 * drift apart on which params they preserve.
 */
export const buildRegisterHref = (identifier: string, next?: string): string => {
  const params = qs.stringify({ email: identifier || undefined, next }, { skipNulls: true });
  return params ? `/auth/register?${params}` : '/auth/register';
};
